<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Package Table Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Projects" active>
        <h3>Projects</h3>
        <project-server-table
          :sample_types="sample_type_collection"
          :test_packages="test_package_collection"
          :show_columns="[
            'pid',
            'customer.full_name',
            'customer_contact',
            'customer_location',
            'sample_types',
            'test_packages',
            'turnarounds',
            'submission_count',
            'created_at',
            'received_percent',
            'prepped_percent',
            'scheduled_percent',
            'results_percent'
          ]"
        />
      </b-tab>
      <b-tab title="Submissions">
        <h3>Submissions</h3>
        <submission-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :test_packages="test_package_collection"
          :show_columns="[
            'pid',
            'project.pid',
            'event_code',
            'project.customer.full_name',
            'sample_type.name',
            'test_package.name',
            'sample_count',
            'created_at',
            'received_percent',
            'prepped_percent',
            'scheduled_percent',
            'results_percent'
          ]"
        />
      </b-tab>
      <b-tab title="Samples">
        <h3>Samples</h3>
        <sample-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :test_packages="test_package_collection"
          :show_columns="[
            'pid',
            'receiving_id',
            'submission.pid',
            'submission.project.customer.full_name',
            'identifier',
            'number',
            'created_at',
            'received',
            'prepped',
            'scheduled'
          ]"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProjectServerTable from "@/components/lab/project/ProjectServerTable";
import SubmissionServerTable from "@/components/lab/submission/SubmissionServerTable";
import SampleServerTable from "@/components/lab/sample/SampleServerTable";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "TestPackageDetailCardstack",
  components: {
    ProjectServerTable,
    SubmissionServerTable,
    SampleServerTable
  },
  data() {
    return {
      loading: true,
      analyte_collection: null,
      sample_type_collection: null,
      test_package_collection: null
    };
  },
  methods: {
    async init() {
      const payload = {
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        limit: "all",
        message: this.$bvToast
      };

      this.analyte_collection = await getCollection({
        ...payload,
        collection_type: "analyte"
      });
      this.sample_type_collection = await getCollection({
        ...payload,
        collection_type: "sample_type"
      });

      this.test_package_collection = await getCollection({
        ...payload,
        collection_type: "test_package"
      });

      this.loading = false;
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>
